import {
  AmpAddBrandColour,
  AmpContentBannerVariant,
  AmpImageSize,
  AmpInGridBannerConfig,
  AmpPersonalContentBannersContainer,
} from "types/amplience";

const VARIANT_MAP = {
  "Brand Light": "brandLight",
  "Brand Light with Border": "brandLightWithBorder",
  "White with Border": "whiteWithBorder",
  Grey: "grey",
  Brand: "brand",
  Black: "black",
} as const;

export const toContentBannerVariant = (v: AmpContentBannerVariant) => VARIANT_MAP[v];

const IMAGE_SIZE_MAP = {
  Small: {
    name: "small",
    aspect: "4:3",
  },
  Large: {
    name: "large",
    aspect: "16:9",
  },
} as const;

export const getImageSizeConfig = (s: AmpImageSize = "Small") => IMAGE_SIZE_MAP[s];

const BRAND_COLOUR_COMPONENT_MAP = {
  Heading: "heading",
  "Sub Heading": "subHeading",
  "Representative Text": "representative",
} as const;

export const getBrandColourComponent = (a?: AmpAddBrandColour) => (!a ? undefined : BRAND_COLOUR_COMPONENT_MAP[a]);

export const isPersonalisedContainer = (
  a?: AmpInGridBannerConfig | AmpPersonalContentBannersContainer,
): a is AmpPersonalContentBannersContainer =>
  Boolean(a?._meta.schema === "https://theverygroup.com/dcx-templating/modules/personalised-content-container");
